
<collapsible-section
    class="collapse-item"
    :id="`objectModelRelationshipsCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
    control-name="objectModelRelationshipsCollapse"
    :is-open="startOpened || isOpen(handler.hasObjectModelRelationshipMatch(lowerQ, objectModel))"
>
  <template #section-header>
    <row>
      <prefix>
        <icon glyph="relationships"/>
      </prefix>
      <column>
        Relationships
      </column>
    </row>
  </template>
  <template #section-contents>
    <object-model-account-relation-data
      v-if="handler.allowAccountRelationSelection"
      :handler="handler"
      :q="q"
      :object-model="objectModel"
      :level="level + 1"
      default-open
      :path="path"
      :parent-tree-context="computedChildTreeContext"
      @select="select"
      :from-model-view="fromModelView"
    />
    <relation-data
        v-for="relation in objectModelRelations"
        :key="`relation-${relation.client_id}-${dropdownControlId}`"
        :relation="relation"
        :handler="handler"
        :object-model="objectModel"
        :path="path"
        :level="level"
        :q="q"
        @select="select"
        :parent-tree-context="parentTreeContext"
    ></relation-data>
    <relation-data
        v-for="relation in inverseObjectModelRelations"
        :key="`relation-${relation.client_id}-inverse-${dropdownControlId}`"
        :relation="relation"
        inverse
        :handler="handler"
        :object-model="objectModel"
        :path="path"
        :level="level"
        :q="q"
        @select="select"
        :parent-tree-context="parentTreeContext"
    ></relation-data>
  </template>
</collapsible-section>
